"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIHeader;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _HeadingConstants = require("../text/HeadingConstants");

var _UIButtonWrapper = _interopRequireDefault(require("./UIButtonWrapper"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex-grow: 1;\n  margin-left: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: 20px;\n  margin-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  min-height: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  margin-bottom: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &::after {\n    content: ' ';\n    position: absolute;\n    left: ", ";\n    bottom: 0;\n    width: calc(100% - ", " * 2);\n    height: 1px;\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// 100% arbitrary cutoff for widthConstrained mode
var CONSTRAINED_TITLE_WIDTH = 544;
var pseudoBorderMixin = (0, _styledComponents.css)(_templateObject(), _sizes.LAYOUT_PADDING_X, _sizes.LAYOUT_PADDING_X, _theme.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR);

var Outer = _styledComponents.default.header.withConfig({
  displayName: "UIHeader__Outer",
  componentId: "h31ohy-0"
})(_templateObject2(), function (_ref) {
  var condensed = _ref.condensed;
  return condensed ? '0' : _sizes.LAYOUT_MAIN_PADDING_TOP;
}, function (_ref2) {
  var tabs = _ref2.tabs;
  return tabs ? '0' : _sizes.HEADER_PADDING_BOTTOM;
}, _sizes.LAYOUT_PADDING_X, _sizes.LAYOUT_PADDING_X, function (_ref3) {
  var breadcrumbs = _ref3.breadcrumbs;
  return breadcrumbs ? '0' : _sizes.HEADER_PADDING_TOP;
}, function (_ref4) {
  var condensed = _ref4.condensed,
      fullWidth = _ref4.fullWidth,
      tabs = _ref4.tabs;
  if (condensed || tabs) return null;
  return fullWidth ? "border-bottom: 1px solid " + _theme.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR : pseudoBorderMixin;
});

var Inner = _styledComponents.default.div.withConfig({
  displayName: "UIHeader__Inner",
  componentId: "h31ohy-1"
})(_templateObject3(), _sizes.INPUT_DEFAULT_HEIGHT, function (_ref5) {
  var tabs = _ref5.tabs;
  return tabs && '8px';
});

var Alert = _styledComponents.default.div.withConfig({
  displayName: "UIHeader__Alert",
  componentId: "h31ohy-2"
})(_templateObject4(), function (_ref6) {
  var tabs = _ref6.tabs;
  return tabs && '20px';
});

var Toolbar = (0, _styledComponents.default)(_UIButtonWrapper.default).attrs({
  justify: 'end'
}).withConfig({
  displayName: "UIHeader__Toolbar",
  componentId: "h31ohy-3"
})(_templateObject5());

var renderTitle = function renderTitle(title, badge) {
  if (!badge) return title;
  var badgeOutput = (0, _react.cloneElement)(badge, {
    className: (0, _classnames.default)(badge.props.className, 'private-header__badge')
  });
  return _react.default.createElement("span", {
    className: "private-header__title__inner"
  }, title, badgeOutput);
};

var renderHeading = function renderHeading(badge, children, headingLevel, title, titleControls) {
  var titleControlsWrapper = titleControls && _react.default.createElement("div", {
    className: "private-header__title-badge"
  }, titleControls);

  var titleWrapperClassName = (0, _classnames.default)('private-header__title', {
    'private-page__title': headingLevel === 'h1'
  });
  var Heading = headingLevel;
  return _react.default.createElement("div", {
    className: titleWrapperClassName
  }, _react.default.createElement(Heading, {
    className: (0, _classnames.default)('private-header__heading', {
      'private-header__heading--solo': !children && !titleControls
    })
  }, renderTitle(title, badge)), titleControlsWrapper);
};

var renderToolbar = function renderToolbar(children) {
  return children && _react.default.createElement(Toolbar, {
    className: "private-header__toolbar"
  }, children);
};
/**
 * Standard page title which allows CTAs, filters, etc.
 */


function UIHeader(props) {
  var alert = props.alert,
      badge = props.badge,
      breadcrumbs = props.breadcrumbs,
      children = props.children,
      className = props.className,
      details = props.details,
      flush = props.flush,
      fullWidth = props.fullWidth,
      headingLevel = props.headingLevel,
      role = props.role,
      tabs = props.tabs,
      title = props.title,
      titleControls = props.titleControls,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["alert", "badge", "breadcrumbs", "children", "className", "details", "flush", "fullWidth", "headingLevel", "role", "tabs", "title", "titleControls", "use"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      widthConstrained = _useState2[0],
      setWidthConstrained = _useState2[1];

  var headerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var measureWidth = function measureWidth() {
      var headerEl = (0, _reactDom.findDOMNode)(headerRef.current);
      var titleEl = headerEl.querySelector('.private-header__title');
      if (!titleEl) return; // Measure width without the width-constrained class

      var hasWidthConstrainedClass = headerEl.classList.contains('private-header--width-constrained');

      if (hasWidthConstrainedClass) {
        headerEl.classList.remove('private-header--width-constrained');
      }

      var newWidthConstrained = titleEl.clientWidth < CONSTRAINED_TITLE_WIDTH;

      if (hasWidthConstrainedClass) {
        headerEl.classList.add('private-header--width-constrained');
      }

      setWidthConstrained(newWidthConstrained);
    };

    measureWidth();
    addEventListener('resize', measureWidth);
    return function () {
      removeEventListener('resize', measureWidth);
    };
  }, []);
  var classes = (0, _classnames.default)('private-header', className, {
    'private-header--full-width': fullWidth,
    'private-header--flush': flush,
    'private-header--with-details': details,
    'private-header--with-tabs': tabs,
    'private-header--width-constrained': widthConstrained
  });
  return _react.default.createElement(Outer, (0, _extends2.default)({
    className: classes,
    ref: headerRef,
    role: "presentation",
    breadcrumbs: breadcrumbs,
    condensed: use === 'condensed',
    fullWidth: fullWidth,
    tabs: tabs
  }, rest), breadcrumbs, _react.default.createElement(Inner, {
    className: "private-header__inner",
    role: role,
    tabs: tabs
  }, title && renderHeading(badge, children, headingLevel, title, titleControls), renderToolbar(children)), details, alert && _react.default.createElement(Alert, {
    tabs: tabs
  }, alert), tabs);
}

UIHeader.propTypes = {
  alert: _propTypes.default.node,
  breadcrumbs: _propTypes.default.node,
  badge: _propTypes.default.node,
  children: _propTypes.default.node,
  details: _propTypes.default.node,
  flush: _propTypes.default.bool.isRequired,
  fullWidth: _propTypes.default.bool.isRequired,
  headingLevel: _propTypes.default.oneOf(_HeadingConstants.HEADING_SIZES),
  tabs: _propTypes.default.node,
  title: _propTypes.default.node,
  titleControls: _propTypes.default.node,
  use: _propTypes.default.oneOf(['condensed'])
};
UIHeader.defaultProps = {
  flush: false,
  // for backwards compat, this will be true in next major version
  fullWidth: true,
  headingLevel: 'h1',
  role: 'banner'
};
UIHeader.displayName = 'UIHeader';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/UIHeader.js
// module id = 359
// module chunks = 209 210 211 212